import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';

import { urlPrefix } from '@components/AppRouter/constants';
import { appStore } from '@stores/appStore';

// проверяем, что вернулись из карточки обратно в справочник
export const useCheckFromDictionaryCard = (path: string): boolean => {
  const [isBack, setIsBack] = useState(true);
  const { locationHistory } = appStore;

  const {
    location: { pathname },
  } = useHistory();

  useEffect(() => {
    const fromPathname = locationHistory.from;
    if (pathname !== fromPathname && path !== fromPathname) {
      setIsBack(fromPathname.replace(urlPrefix, '').split('/')[1] === path.replace(urlPrefix, '').split('/')[1]);
    }
  }, [locationHistory, path, pathname]);

  return useMemo(() => isBack, [isBack]);
};
